module.exports = __webpack_public_path__ + "static/media/marie.684f926f.jpg";